import React, { useState, useEffect } from "react";
import parse from 'html-react-parser';

const StaticTypeWriterWithParser = (props) => {
  const [currentText, setCurrentText] = useState(""); // Text revealed so far
  const [currentIndex, setCurrentIndex] = useState(0); // Index of the current character
  const delay = 10;
  const effects = props.effects === false ? false : true;

  useEffect(() => {
    if (effects && currentIndex < props.text.length) {
      // Gradually reveal the content
      const timeout = setTimeout(() => {
        setCurrentText((prev) => prev + props.text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, delay);
      return () => clearTimeout(timeout);
    } else {
      props.setLoading && props.setLoading(true); // Mark as complete when done
    }
  }, [currentIndex, props.text, props.setLoading]);

  return (
    <div>
      { effects ? 
          <div>
            {/* Parse the dynamically revealed content */}
            {parse(currentText)}
          </div>
          :
          <div>
            {parse(props.text)}
          </div>
      }
    </div>
  );
};

export default StaticTypeWriterWithParser;